import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import * as $ from 'jquery';
import { ZinuzhXoragir } from './zinujXoragir';
import { Location } from '@angular/common';
import 'rxjs/add/operator/catch';
import {Globals} from '../globals';

@Component({
  selector: 'app-zinuj-xoragir',
  templateUrl: './zinuj-xoragir.component.html',
  styleUrls: ['./zinuj-xoragir.component.scss']
})
export class ZinujXoragirComponent implements OnInit {
zinujXoragir:ZinuzhXoragir
  page:any;
  date:any;
  selectedDateOn ;
  url ;
  curent;
  selectedDateOff ;
  somethingChanged: any;
  dataToSend:any;
  p: any = 1;
  collection: any[]=[];

   today: any;
   todays: any;


  constructor(private http: HttpClient , public globals: Globals, private route: ActivatedRoute , public _router:Router , public _location:Location) {
    var url_string = location.href;
    this.url = url_string;
    this.curent = url_string.substr(url_string.lastIndexOf('/') + 1);
   }
   dateChanged(val: any) {
    var num; ;
    this.somethingChanged = val.value.toString().split(" ");
     if(this.somethingChanged[1] == "Jan") {
      num = '01';
    } else if(this.somethingChanged[1] == "Feb") {
      num = '02';
    }
    else if(this.somethingChanged[1] == "Mar") {
      num = '03';
    }
    else if(this.somethingChanged[1] == "Apr") {
      num = '04';
    }
    else if(this.somethingChanged[1] == "May") {
      num = '05';
    }
    else if(this.somethingChanged[1] == "Jun") {
      num = '06';
    }
    else if(this.somethingChanged[1] == "Jul") {
      num = '07';
    }
    else if(this.somethingChanged[1] == "Aug") {
      num = '08';
    }
    else if(this.somethingChanged[1] == "Sep") {
      num = '09';
    }
    else if(this.somethingChanged[1] == "Oct") {
      num = '10';
    }
    else if(this.somethingChanged[1] == "Nov") {
      num = '11';
    }
    else if(this.somethingChanged[1] == "Dec") {
      num = '12';
    }
this.dataToSend = this.somethingChanged[3] + "-"+num + "-"+ this.somethingChanged[2]
    // console.log(this.dataToSend)
    this.http.get<ZinuzhXoragir>(this.globals.urlMain +'zinuj/'+ this.curent, {
      params:{
        data: this.dataToSend
      }

    }).subscribe(data => {
      this.zinujXoragir = data;
      var k =Number(data.meta.total);
      this.collection=[];
       for(let i =0 ; i<= k; i++) {
         this.collection.push(i)
       }
    });
    $(window).scrollTop(0);
  }
 lang = localStorage.getItem('lang')?localStorage.getItem('lang'):'hy'
  ngOnInit() {
    this.http.get<ZinuzhXoragir>(this.globals.urlMain +'zinuj/'+ this.curent).subscribe(data => {
      this.zinujXoragir = data;

    });

    $(window).scrollTop(0);

    this.today = new Date().toISOString().split('T')[0];
  this.changeReq();
  }
  changel(){
    this.changeReq();

  }
  changeReq(){
    $(window).scrollTop(0);
    if(this.selectedDateOn && this.selectedDateOff) {
     this.http.get<ZinuzhXoragir>(this.globals.urlMain +'zinuj/'+ this.curent, {
       params:{
          page: this.p,

       }

     }).subscribe(data => {
       this.zinujXoragir = data;
       var k =Number(data.meta.total);
      this.collection=[];
       for(let i =0 ; i<= k; i++) {
         this.collection.push(i)
       }


     });
    } else {
     this.http.get<ZinuzhXoragir>(this.globals.urlMain +'zinuj/'+ this.curent, {
       params:{
          page: this.p,

       }

     }).subscribe(data => {
       this.zinujXoragir = data;
       var k =Number(data.meta.total);
      this.collection=[];
       for(let i =0 ; i<= k; i++) {
         this.collection.push(i)
       }


     });
    }


   }
   openModal(event) {
    $('.modalForVideos').addClass('shown')
    var target = event.target || event.srcElement || event.currentTarget;
    var title = $(target).closest('.itemContent').find('.title').text();
    var iframe = $(target).closest('.iframe').find('img').attr('data-id');
    var newIframe = document.createElement('iframe');
    newIframe.src = iframe;
    newIframe.height="100%";
    newIframe.width="100%";
    newIframe.allowFullscreen= true
    $('.modalTitle').html(title);
    $('.modileIframe').html(newIframe);
  }
  closeModal() {
    $('.modileIframe').html('');
    $('.modalDescription').html('');
    $('.modalForVideos').removeClass('shown');
  }
}
